import React, { FunctionComponent, MouseEvent } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { IBindingAction, IBindingCallback1 } from '../../common/models/callback';
import styles from './styles.module.scss';
import { concat } from '../../common/helpers/arrayHelper';

interface IProps {
  textIntlId: string;
  defaultMessage?: string;
  intlValues?: Record<string, any>;
  onClick?: IBindingAction | IBindingCallback1<MouseEvent<HTMLElement>>;
  onMouseDown?: IBindingAction;
  icon?: JSX.Element;
  size?: 'md' | 'lg';
  iconPosition?: 'left' | 'right';
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  enableAction?: boolean;
}

const LinkButton: FunctionComponent<IProps> = ({
  textIntlId,
  defaultMessage,
  size = 'md',
  icon,
  iconPosition = 'left',
  disabled,
  enableAction,
  variant = 'primary',
  intlValues = {},
  onClick,
  onMouseDown
}) => (
  <Button
    className={concat(
      styles.linkBtn,
      styles[size],
      disabled ? styles.disabled : '',
      variant === 'primary' ? styles.primary : styles.secondary
    )}
    type="button"
    variant="link"
    onClick={onClick}
    onMouseDown={onMouseDown}
    disabled={Boolean(disabled) && !enableAction}
  >
    {icon && <span className={styles[iconPosition]}>{icon}</span>}
    <FormattedMessage values={intlValues} id={textIntlId} defaultMessage={defaultMessage || textIntlId} />
  </Button>
);

export default LinkButton;
